import React, {ReactNode} from "react";
import './form.scss';

interface Props {
    className?: string,
    checked?: boolean;
    onClick?: (arg: any) => any;
    label: string | ReactNode;
    name: string;
    id: string;
    disabled?: boolean;
    required?: boolean;
    errors?: string,
}


const Checkbox = ({
                      className,
                      checked,
                      onClick,
                      label,
                      name,
                      id,
                      disabled = false,
                      required = false,
                      errors,
                  }: Props) => (
    <div className={["checkboxLabelContainer", className].join(' ')}>
        <input
            id={id}
            name={name}
            type='checkbox'
            checked={checked}
            onClick={onClick}
            onChange={onClick}
            disabled={disabled}
            required={required}
        />
        <label htmlFor={id}>
            {label}
            {
                errors ? (<>&nbsp;·&nbsp;<span className='errorText'>{errors}</span></>) : null
            }
        </label>
    </div>
);

export default Checkbox;